module.exports = __webpack_public_path__ + "files/79382c03ff8f7d4720a34b812b663b0a.png";